/* eslint-disable prefer-promise-reject-errors */
import { useMutation } from "@apollo/client";
import { Button, Form, Radio, message } from "antd";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import PhoneInputWithCountrySelect, { isValidPhoneNumber } from "react-phone-number-input";
import { useDispatch } from "react-redux";
import { UPDATE_LEAD_PHONE_LIST } from "../../../graphql/mutation";
import { serializePhoneNumbers } from "../../../library/utils";
import { updateLeadInList } from "../../../redux/slices/leadSlice";

export const PhoneFormJsx = ({
  phones,
  phoneRef,
  selectedLead,
  setSelectedLead,
  phoneArr,
  showPrimary = true,
}) => {
  const close = () => phoneRef?.current?.click();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [phoneData, setphoneData] = useState(
    phones.map(item => {
      const temp = structuredClone(item);
      delete temp.potentialLeads;
      delete temp.leadId;
      return temp;
    })
  );
  const [primaryPhoneType, setprimaryPhoneType] = useState(phoneArr[0]);
  const [updateLeadPhone, { loading: updateLeadLoader }] = useMutation(UPDATE_LEAD_PHONE_LIST);

  const handleSavePhone = async () => {
    for (let phone = 0; phone < phoneData.length; phone++) {
      const element = phoneData[phone];
      if (!isEmpty(element.phone) && !isValidPhoneNumber(element.phone)) {
        return message.error(`Please enter a valid ${element.phoneType} phone number`);
      }
    }
    console.log(phoneData);
    const res = await updateLeadPhone({
      variables: {
        phones: phoneData.map(item => {
          let temp = structuredClone(item);
          temp = { ...temp, isPrimary: showPrimary ? temp.phoneType === primaryPhoneType : false };
          return temp;
        }),
        leadId: selectedLead.id,
      },
    });
    if (res.data.updateLead.statusCode === 200) {
      setSelectedLead({ ...selectedLead, ...res.data.updateLead.lead });
      message.success(res.data.updateLead.message);
      dispatch(updateLeadInList({ ...selectedLead, ...res.data.updateLead.lead }));
      close();
    } else {
      message.error(res.data.updateLead.message);
    }
  };

  useEffect(() => {
    const existingPhones = phones.filter(item => item.id);
    if (existingPhones.length > 0) {
      const obj = phones.filter(item => item.id).map(item => ({ [item.phoneType]: item.phone }));
      console.log(serializePhoneNumbers(obj));
      if (obj) form.setFieldsValue(serializePhoneNumbers(obj));
    }
    if (phones.length > 0) {
      const primaryPhone = phones.find(item => item.isPrimary);
      if (primaryPhone) {
        setprimaryPhoneType(primaryPhone.phoneType);
      }
    }
  }, [phones]);
  const getPhone = type => {
    const phone = phones.find(item => item.phoneType === type);
    if (phone) return phone.phone;
  };
  const setPhone = (value, type) => {
    const index = phoneData.findIndex(item => item.phoneType === type);
    if (index !== -1) {
      setphoneData(prev => {
        const phones = structuredClone(prev);
        phones[index] = {
          ...phones[index],
          phone: value,
        };
        return phones;
      });
    } else {
      setphoneData([...phoneData, { phoneType: type, phone: value }]);
    }
  };
  return (
    <Form form={form} layout="vertical" onFinish={handleSavePhone}>
      {showPrimary && (
        <div className="flex-row-centered justify-end items-center">
          <span>Primary</span>
        </div>
      )}
      <Radio.Group
        value={primaryPhoneType}
        onChange={e => setprimaryPhoneType(e.target.value)}
        className="flex-col-centered items-center"
      >
        {phoneArr.map((item, index) => {
          return (
            <Form.Item
              key={index}
              rules={[
                {
                  required: showPrimary ? item === primaryPhoneType : true,
                  message: `Please enter ${showPrimary ? primaryPhoneType : item} phone number`,
                },
              ]}
              name={item}
              className="xs-600"
              label={`${item}`}
            >
              <div className="flex-row-centered items-center justify-between gap-2 w-full">
                <PhoneInputWithCountrySelect
                  onChange={value => {
                    if (isEmpty(value)) {
                      console.log(value);
                      form.setFieldValue(item, "");
                      setPhone("", item);
                    } else {
                      form.setFieldValue(item, value);
                      setPhone(value, item);
                    }
                  }}
                  value={getPhone(item)}
                  name={item}
                  className="aboutThisLead"
                  // className="h-[21px] px-2 py-1 rounded-sm border-[1px] border-solid border-grey-200"
                />{" "}
                {showPrimary && <Radio value={item} />}
              </div>
            </Form.Item>
          );
        })}
      </Radio.Group>

      <div className="flex-row-centered -m-3 px-3 py-2 mt-1 bg-grey-150 gap-1 items-center">
        <Button loading={updateLeadLoader} type="primary" htmlType="submit">
          Save
        </Button>
        <Button onClick={close}>Cancel</Button>
      </div>
    </Form>
  );
};
